<template>
<div class="chapter">
<div class="inner_page">
<h3 class="calibre4">Vorworte</h3>
<p class="center">Aus dem Vorwort zur zweiten Auflage.</p>
<p class="calibre2">Bei aller Veränderung im einzelnen hat unser Werk in der zweiten
Auflage den Plan der ersten durchaus festgehalten. Es möchte durch
eine geschichtliche Vorführung der Lebensanschauungen der großen
Denker zunächst dafür wirken, daß die Helden des Gedankens nicht
bloß wie leblose und gleichförmige Schatten an uns vorüberziehen,
sondern daß ihre Gestalten Fleisch und Blut gewinnen und zugleich
einen eigentümlichen Charakter zeigen; so allein kann die Kraft und
Leidenschaft, welche ihre Schöpfungen durchströmt, auch unserer
eigenen Arbeit zufließen. Insofern darf das Werk sich als ein
Supplement zu allen Darstellungen der Geschichte der Philosophie
geben, ohne sie irgend ersetzen zu wollen.</p>
<p class="calibre2">Zugleich aber hofft es der Philosophie selbst einen Dienst zu
leisten, indem es eine Art Einleitung in ihre Hauptprobleme bietet.
Die Lebensanschauung eines großen Denkers läßt sich nicht
entwickeln, ohne daß diese Probleme deutlich zur Sprache kommen,
sie müssen sich hier, in dem Zusammenhange mit dem Ganzen der
lebendigen Persönlichkeit und ihrem starken Verlangen nach Glück,
besonders durchsichtig und eindringlich darstellen.</p>
<p class="calibre2">Endlich kämpft das Werk für einen engeren Zusammenhang der
Philosophie mit dem allgemeinen Leben. Die gegenwärtige Spaltung,
die Gleichgültigkeit weiterer Kreise gegen die Philosophie und die
Abschließung der Philosophie zu einer gelehrten Fachwissenschaft,
ist ein großer Schaden für beide Teile; es gehört zur Gesundung
unseres geistigen Lebens, daß <a class="pcalibre1 pcalibre2 pcalibre pcalibre3" id="page4" title="lac/DaoH"></a> man sich wieder mehr um einander kümmere. Ist aber
nicht die Lebensanschauung ein Punkt, wo die philosophische Arbeit
dem reinmenschlichen Interesse besonders nahe kommt? Sollte es
nicht alle Gebildeten treiben, bei einer Frage, die so sehr unser
eigenes Glück angeht, eine Fühlung mit den Meistern des Gedankens
zu gewinnen?</p>
<p class="calibre2"> </p>
<p class="right"><em class="calibre5">Jena</em>, im Herbst 1896.<br class="calibre1"/>
Rudolf Eucken. <a class="pcalibre1 pcalibre2 pcalibre pcalibre3" id="page5" title="lac/DaoH"></a></p>
<p class="right"> </p>
<p class="center">Vorwort zur zwölften Auflage.</p>
<p class="calibre2">Die Lebensanschauungen der großen Denker haben durch die Reihe
der Auflagen hindurch manche Veränderung erfahren, unablässig war
ich bemüht, an dem Buche zu feilen und es auch sachlich
weiterzuführen. Durch alle Veränderung hindurch ist aber sein
Grundgedanke festgehalten. Ein Überblick und eine Würdigung der
geschichtlichen Bewegung des Lebensproblems läßt sich in
verschiedener Weise unternehmen; so auch in der Art, daß man sich
in einen geschlossenen Gedankenkreis stellt, an ihm alle Leistung
mißt, von ihm aus ihre ganze Fülle in ein Für oder Wider zerlegt.
Das hat den Vorteil einer schärferen Beleuchtung und einer
direkteren Verwertung, es kann den Leser stärker erregen und mehr
zur Parteinahme zwingen. Aber es hat auch die Gefahr einer
Verengung, die Gefahr fremde Maße an die Dinge zu legen, ferner
Licht und Schatten ungerecht zu verteilen. Demgegenüber behält ein
gutes Recht eine Behandlung, welche vornehmlich danach strebt, die
Gedankenwelten in ihrem eigenen Wollen und Wirken zu erfassen und
sie möglichst ungetrübt vorzuführen, an den Leistungen möglichst
das Förderliche zu sehen und zugleich die Bewegung mehr als ein
gemeinsames Werk der Menschheit zu verstehen. Nur so lassen sich
die verschiedenen Aufgaben, die den menschlichen Geist beschäftigen
und immerfort beschäftigen müssen, gleichmäßig würdigen und
miteinander verbinden, nur so läßt sich der Gesamtertrag des
menschlichen Strebens ohne Parteisinn überschauen. Eine solche
vornehmlich auf innere Erweiterung und Befestigung gerichtete
Behandlung scheint besonders notwendig in einer Zeit, die so sehr
wie die Gegenwart in Sekten und Parteien zerfällt und so sehr
innerer Sammlung bedarf; an ihrem Teile mag solche Behandlung
<a class="pcalibre1 pcalibre2 pcalibre pcalibre3" id="page6" title="lac/wedi"></a> zur Stärkung des
Bewußtseins gemeinsamer Geschicke und Ziele wirken. Auch die Stürme
des Weltkrieges durften ein solches Streben nicht beirren.</p>
<p class="calibre2">Auch die zwölfte Auflage bringt verschiedene Veränderungen. Der
Klarheit und Flüssigkeit der Darstellung ward weitere Sorge
zugewandt, im besonderen habe ich manche Fremdwörter ausgemerzt. So
wenig ich alle Fremdwörter missen möchte, nach meiner Überzeugung
erhalten sich davon noch immer viele völlig entbehrliche in unserer
Sprache zur Gefährdung der Schönheit des Ausdrucks wie der Klarheit
des Denkens.</p>
<p class="calibre2">In der Sache ist die Wirkung des langen Weltkriegs und der
dadurch erwachsenen Lage der Menschheit mehr zur Geltung gelangt,
der schweren Erschütterung herkömmlicher Ziele und Werte sowie dem
tiefen Ernst der Gegenwart und nächsten Zukunft kann sich eine
Untersuchung unmöglich entziehen, welche ein Gesamtbild
menschlichen Strebens nach Wahrheit und Glück geben möchte. Es
bewirkte das namentlich bei der Neuzeit eine Umgestaltung der
zusammenfassenden Betrachtungen, auch in die Schlußabschnitte wurde
mehr eigne Energie und Forderung hineingelegt.</p>
<p class="calibre2">Beim Stoff trieb eine unverkennbare Wendung des
Menschheitslebens zu einer genaueren Behandlung der staatlichen und
gesellschaftlichen Fragen; von den Einzeldarstellungen wurde
namentlich die Luthers erweitert und vertieft, das namentlich unter
dem durch die Feier des vergangenen Jahres erweckten Eindruck, daß
Luther, trotz aller Tüchtigkeit der ihm gewidmeten Forschung, im
Ganzen seines Strebens und Wesens dem deutschen Volke heute noch
viel zu wenig bekannt ist. Diesen Punkt zur Sprache zu bringen
mußte sich ein Werk für verpflichtet halten, das bei allem Streben
zum Ganzen der Menschheit an erster Stelle für Deutsche geschrieben
ist und deutsche Art fördern möchte.</p>
<p class="calibre2">So hofft denn unser Werk in der neuen Gestalt sich die alten
Freunde zu erhalten und zu ihnen neue zu gewinnen.</p>
<p class="right"><em class="calibre5">Jena</em>, im Mai 1918.<br class="calibre1"/>
Rudolf Eucken.</p>
<p class="calibre2"><a class="pcalibre1 pcalibre2 pcalibre pcalibre3" id="page7" title="lac/wedi"></a> <a class="pcalibre1 pcalibre2 pcalibre pcalibre3" id="page8" title="lac/wedi"></a> <a class="pcalibre1 pcalibre2 pcalibre pcalibre3" id="page9" title="lac/wedi"></a> <a class="pcalibre1 pcalibre2 pcalibre pcalibre3" id="page10" title="lac/wedi"></a> <a class="pcalibre1 pcalibre2 pcalibre pcalibre3" id="page11" title="lac/Konmax"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?0cbd5a9e